import { costBreakdownV2WidgetSetupDataSelector } from "./costBreakdownV2WidgetSetupDataSelector";
import { RootState } from "../../../../../store";
import { ResourceExplorerGridDataWithId } from "../../../../../resource-explorer/utils/types/resourceExplorerDataGrid";
import { formatCostBreakdownREDataGridData } from "../../../../utils/helpers/costBreakdown/formatCostBreakdownREDataGridData";

export const costBreakdownV2WidgetSetupTotalDataWithIdsSelector = (
  state: RootState,
): ResourceExplorerGridDataWithId[] | undefined => {
  const data = costBreakdownV2WidgetSetupDataSelector(state)?.total;
  return formatCostBreakdownREDataGridData(data ?? [], true) ?? [];
};
